// Soccer Skills
const soccer_dribbling_skill = {
  id: 101,
  sport: 'soccer',
  skill: 'dribbling',
  title: 'Dribbling Master',
  description: 'Learn to control the ball with your feet',
  difficulty: 'beginner',
  ageRange: '6-10',
  duration: 10,
  points: 15,
  intro:
    "Hey soccer stars! Ready to become a dribbling master? This skill will teach you to control the ball like a pro! You'll need a soccer ball and some space to move around. Let's get started!",
  completion:
    "AMAZING! You're a soccer DRIBBLING MASTER! You just learned to control the ball with your feet like a professional! Your ball control is incredible now, and you're going to weave through defenders like magic! You're ready to be the best dribbler on your team! You're a true champion!",
};

const soccer_passing_skill = {
  id: 102,
  sport: 'soccer',
  skill: 'passing',
  title: 'Passing Pro',
  description: 'Master accurate passing to teammates',
  difficulty: 'beginner',
  ageRange: '6-10',
  duration: 10,
  points: 15,
  intro:
    "Hey soccer stars! Ready to become a passing pro? This skill will teach you to pass the ball accurately to your teammates! You'll need a soccer ball and a wall or a partner to practice with. Let's get started!",
  completion:
    "INCREDIBLE! You're a soccer PASSING PRO! You just learned to pass the ball with perfect accuracy! Your passing skills are amazing now, and you're going to set up your teammates for goals! You're ready to be the best passer on your team! You're a true champion!",
};

const soccer_technique_skill = {
  id: 103,
  sport: 'soccer',
  skill: 'technique',
  title: 'Technique Practice',
  description: 'Master soccer technique and form',
  difficulty: 'beginner',
  ageRange: '6-10',
  duration: 10,
  points: 15,
  intro:
    "Hey soccer stars! Ready to master soccer technique? This skill will teach you proper form and ball control! You'll need a soccer ball and some space to practice. Let's get started!",
  completion:
    "FANTASTIC! You're a soccer TECHNIQUE MASTER! You just learned proper soccer form and ball control! Your technique is incredible now, and you're going to play like a professional! You're ready to be the most skilled player on your team! You're a true champion!",
};

// Soccer Partner Skills
const soccer_partner_passing_skill = {
  id: 104,
  sport: 'soccer',
  skill: 'partner_passing',
  title: 'Partner Passing',
  description: 'Master teamwork through passing',
  difficulty: 'beginner',
  ageRange: '6-10',
  duration: 10,
  points: 15,
  intro:
    "Hey soccer stars! Ready to master partner passing? This skill will teach you to work together as a team! You'll need a soccer ball and a partner to practice with. Let's get started!",
  completion:
    "AMAZING! You're a soccer PARTNER PASSING MASTER! You just learned to work together as a team! Your teamwork skills are incredible now, and you're going to pass like champions! You're ready to be the best team players! You're true champions!",
};

const soccer_partner_control_skill = {
  id: 105,
  sport: 'soccer',
  skill: 'partner_control',
  title: 'Partner Control',
  description: 'Control the ball with your partner',
  difficulty: 'beginner',
  ageRange: '6-10',
  duration: 10,
  points: 15,
  intro:
    "Hey soccer stars! Ready to master partner control? This skill will teach you to control the ball together! You'll need a soccer ball and a partner to practice with. Let's get started!",
  completion:
    "INCREDIBLE! You're soccer PARTNER CONTROL MASTERS! You just learned to control the ball together! Your partner control skills are amazing now, and you're going to control like champions! You're ready to be the best control team! You're true champions!",
};

const soccer_partner_dribbling_skill = {
  id: 106,
  sport: 'soccer',
  skill: 'partner_dribbling',
  title: 'Partner Dribbling',
  description: 'Dribble together as a team',
  difficulty: 'intermediate',
  ageRange: '6-10',
  duration: 10,
  points: 20,
  intro:
    "Hey soccer stars! Ready to master partner dribbling? This skill will teach you to dribble together as a team! You'll need a soccer ball and a partner to practice with. Let's get started!",
  completion:
    "FANTASTIC! You're soccer PARTNER DRIBBLING MASTERS! You just learned to dribble together as a team! Your partner dribbling skills are incredible now, and you're going to dribble like champions! You're ready to be the best dribbling team! You're true champions!",
};

const soccer_partner_skills_skill = {
  id: 107,
  sport: 'soccer',
  skill: 'partner_skills',
  title: 'Partner Skills',
  description: 'Master advanced partner techniques',
  difficulty: 'advanced',
  ageRange: '6-10',
  duration: 10,
  points: 25,
  intro:
    "Hey soccer stars! Ready to master advanced partner skills? This skill will teach you the most advanced partner techniques! You'll need a soccer ball and a partner to practice with. Let's get started!",
  completion:
    "PHENOMENAL! You're soccer PARTNER SKILLS MASTERS! You just learned the most advanced partner techniques! Your partner skills are incredible now, and you're going to perform like champions! You're ready to be the best partner team! You're true champions!",
};

// Basketball Skills
const basketball_dribbling_skill = {
  id: 104,
  sport: 'basketball',
  skill: 'dribbling',
  title: 'Dribbling Wizard',
  description: 'Control the ball like a pro',
  difficulty: 'beginner',
  ageRange: '6-10',
  duration: 10,
  points: 15,
  intro:
    "Hey basketball stars! Ready to become a dribbling wizard? This skill will teach you to control the ball like a pro! You'll need a basketball and some space to move around. Let's get started!",
  completion:
    "AMAZING! You're a basketball DRIBBLING WIZARD! You just learned to control the ball with your hands like a professional! Your ball handling is incredible now, and you're going to dribble past defenders like magic! You're ready to be the best dribbler on your team! You're a true champion!",
};

const basketball_shooting_skill = {
  id: 105,
  sport: 'basketball',
  skill: 'shooting',
  title: 'Shooting Champion',
  description: 'Make every shot count',
  difficulty: 'beginner',
  ageRange: '6-10',
  duration: 10,
  points: 15,
  intro:
    "Hey basketball stars! Ready to become a shooting champion? This skill will teach you to make every shot count! You'll need a basketball and a basket or hoop to practice with. Let's get started!",
  completion:
    "INCREDIBLE! You're a basketball SHOOTING CHAMPION! You just learned to shoot the ball with perfect form! Your shooting skills are amazing now, and you're going to score baskets like a professional! You're ready to be the top scorer on your team! You're a true champion!",
};

const basketball_defense_skill = {
  id: 106,
  sport: 'basketball',
  skill: 'defense',
  title: 'Defense Guard',
  description: 'Stop the other team from scoring',
  difficulty: 'intermediate',
  ageRange: '6-10',
  duration: 10,
  points: 20,
  intro:
    "Hey basketball stars! Ready to become a defense guard? This skill will teach you to stop the other team from scoring! You'll need some space to move around and practice your defensive stance. Let's get started!",
  completion:
    "FANTASTIC! You're a basketball DEFENSE GUARD! You just learned to play defense like a professional! Your defensive skills are incredible now, and you're going to stop opponents from scoring! You're ready to be the best defender on your team! You're a true champion!",
};

// Martial Arts Skills
const martial_arts_beginner_stances_skill = {
  id: 1074,
  sport: 'martial_arts',
  skill: 'beginner_stances',
  title: 'Beginner Stances',
  description: 'Learn fundamental martial arts stances',
  difficulty: 'beginner',
  ageRange: '6-10',
  duration: 17,
  points: 17,
  intro:
    "Hey martial arts stars! Ready to learn your first stances? This skill will teach you the foundation of all martial arts! You'll need some space to practice your stances and movements. Let's get started!",
  completion:
    "AMAZING! You're a martial arts STANCE MASTER! You just learned to hold proper stances like a professional! Your foundation is incredible now, and you're going to be stable and powerful! You're ready to be the strongest martial artist in your class! You're a true champion!",
};

const martial_arts_intermediate_stances_skill = {
  id: 1075,
  sport: 'martial_arts',
  skill: 'intermediate_stances',
  title: 'Intermediate Stances',
  description: 'Master intermediate martial arts stances',
  difficulty: 'intermediate',
  ageRange: '6-10',
  duration: 18,
  points: 18,
  intro:
    "Hey martial arts stars! Ready to level up your stances? This skill will teach you advanced stance techniques! You'll need some space to practice your stances and movements. Let's get started!",
  completion:
    "INCREDIBLE! You're an INTERMEDIATE STANCE MASTER! You just learned advanced stances like a professional! Your foundation is rock solid now, and you're going to be unstoppable! You're ready to be the strongest martial artist in your class! You're a true champion!",
};

const martial_arts_advanced_stances_skill = {
  id: 1076,
  sport: 'martial_arts',
  skill: 'advanced_stances',
  title: 'Advanced Stances',
  description: 'Master advanced martial arts stances',
  difficulty: 'advanced',
  ageRange: '6-10',
  duration: 15,
  points: 15,
  intro:
    "Hey martial arts stars! Ready to master the most advanced stances? This skill will teach you expert-level stance techniques! You'll need some space to practice your stances and movements. Let's get started!",
  completion:
    "FANTASTIC! You're an ADVANCED STANCE MASTER! You just learned expert stances like a professional! Your foundation is unbreakable now, and you're going to be unstoppable! You're ready to be the strongest martial artist in your class! You're a true champion!",
};

const martial_arts_beginner_strikes_skill = {
  id: 1080,
  sport: 'martial_arts',
  skill: 'beginner_strikes',
  title: 'Beginner Strikes',
  description: 'Learn fundamental martial arts strikes',
  difficulty: 'beginner',
  ageRange: '6-10',
  duration: 18,
  points: 18,
  intro:
    "Hey martial arts stars! Ready to learn your first strikes? This skill will teach you powerful and accurate strikes! You'll need some space to practice your punches and kicks safely. Let's get started!",
  completion:
    "AMAZING! You're a martial arts STRIKING MASTER! You just learned to strike with power and accuracy like a professional! Your striking skills are incredible now, and you're going to be fast and powerful! You're ready to be the best striker in your class! You're a true champion!",
};

const martial_arts_intermediate_strikes_skill = {
  id: 1081,
  sport: 'martial_arts',
  skill: 'intermediate_strikes',
  title: 'Intermediate Strikes',
  description: 'Master intermediate martial arts strikes',
  difficulty: 'intermediate',
  ageRange: '6-10',
  duration: 20,
  points: 20,
  intro:
    "Hey martial arts stars! Ready to level up your strikes? This skill will teach you advanced striking techniques! You'll need some space to practice your punches and kicks safely. Let's get started!",
  completion:
    "INCREDIBLE! You're an INTERMEDIATE STRIKING MASTER! You just learned advanced strikes like a professional! Your striking skills are amazing now, and you're going to be fast and powerful! You're ready to be the best striker in your class! You're a true champion!",
};

const martial_arts_advanced_strikes_skill = {
  id: 1082,
  sport: 'martial_arts',
  skill: 'advanced_strikes',
  title: 'Advanced Strikes',
  description: 'Master advanced martial arts strikes',
  difficulty: 'advanced',
  ageRange: '6-10',
  duration: 18,
  points: 18,
  intro:
    "Hey martial arts stars! Ready to master the most advanced strikes? This skill will teach you expert-level striking techniques! You'll need some space to practice your punches and kicks safely. Let's get started!",
  completion:
    "FANTASTIC! You're an ADVANCED STRIKING MASTER! You just learned expert strikes like a professional! Your striking skills are incredible now, and you're going to be unstoppable! You're ready to be the best striker in your class! You're a true champion!",
};

const martial_arts_beginner_blocks_skill = {
  id: 1083,
  sport: 'martial_arts',
  skill: 'beginner_blocks',
  title: 'Beginner Blocks',
  description: 'Learn fundamental martial arts blocks',
  difficulty: 'beginner',
  ageRange: '6-10',
  duration: 15,
  points: 15,
  intro:
    "Hey martial arts stars! Ready to learn your first blocks? This skill will teach you to defend yourself with powerful blocks! You'll need some space to practice your defensive moves safely. Let's get started!",
  completion:
    "AMAZING! You're a martial arts BLOCKING MASTER! You just learned to block with perfect timing like a professional! Your defensive skills are incredible now, and you're going to be unstoppable! You're ready to be the best defender in your class! You're a true champion!",
};

const martial_arts_intermediate_blocks_skill = {
  id: 1084,
  sport: 'martial_arts',
  skill: 'intermediate_blocks',
  title: 'Intermediate Blocks',
  description: 'Master intermediate martial arts blocks',
  difficulty: 'intermediate',
  ageRange: '6-10',
  duration: 22,
  points: 22,
  intro:
    "Hey martial arts stars! Ready to level up your blocks? This skill will teach you advanced blocking techniques! You'll need some space to practice your defensive moves safely. Let's get started!",
  completion:
    "INCREDIBLE! You're an INTERMEDIATE BLOCKING MASTER! You just learned advanced blocks like a professional! Your defensive skills are amazing now, and you're going to be unstoppable! You're ready to be the best defender in your class! You're a true champion!",
};

const martial_arts_advanced_blocks_skill = {
  id: 1085,
  sport: 'martial_arts',
  skill: 'advanced_blocks',
  title: 'Advanced Blocks',
  description: 'Master advanced martial arts blocks',
  difficulty: 'advanced',
  ageRange: '6-10',
  duration: 18,
  points: 18,
  intro:
    "Hey martial arts stars! Ready to master the most advanced blocks? This skill will teach you expert-level blocking techniques! You'll need some space to practice your defensive moves safely. Let's get started!",
  completion:
    "FANTASTIC! You're an ADVANCED BLOCKING MASTER! You just learned expert blocks like a professional! Your defensive skills are incredible now, and you're going to be unstoppable! You're ready to be the best defender in your class! You're a true champion!",
};

// Boxing Skills
const boxing_basics_skill = {
  id: 111,
  sport: 'boxing',
  skill: 'basics',
  title: 'Boxing Basics Master',
  description: 'Learn fundamental boxing techniques',
  difficulty: 'beginner',
  ageRange: '6-10',
  duration: 10,
  points: 15,
  intro:
    "Hey boxing stars! Ready to become a boxing basics master? This skill will teach you basic boxing stance and punches! You'll need some space to practice your boxing moves safely. Let's get started!",
  completion:
    "AMAZING! You're a boxing BASICS MASTER! You just learned basic boxing techniques like a professional! Your boxing foundation is incredible now, and you're going to be a powerful fighter! You're ready to be the best boxer in your class! You're a true champion!",
};

const boxing_footwork_skill = {
  id: 112,
  sport: 'boxing',
  skill: 'footwork',
  title: 'Boxing Footwork Pro',
  description: 'Master boxing movement and footwork',
  difficulty: 'intermediate',
  ageRange: '6-10',
  duration: 10,
  points: 20,
  intro:
    "Hey boxing stars! Ready to become a boxing footwork pro? This skill will teach you boxing movement and footwork! You'll need some space to practice your boxing steps safely. Let's get started!",
  completion:
    "INCREDIBLE! You're a boxing FOOTWORK PRO! You just learned boxing movement like a professional! Your footwork is amazing now, and you're going to be fast and agile! You're ready to be the best mover in your class! You're a true champion!",
};

const boxing_defense_skill = {
  id: 113,
  sport: 'boxing',
  skill: 'defense',
  title: 'Boxing Defense Champion',
  description: 'Learn defensive boxing techniques',
  difficulty: 'intermediate',
  ageRange: '6-10',
  duration: 10,
  points: 20,
  intro:
    "Hey boxing stars! Ready to become a boxing defense champion? This skill will teach you boxing defensive movements and blocks! You'll need some space to practice your defensive moves safely. Let's get started!",
  completion:
    "FANTASTIC! You're a boxing DEFENSE CHAMPION! You just learned defensive boxing like a professional! Your defensive skills are incredible now, and you're going to be unstoppable! You're ready to be the best defender in your class! You're a true champion!",
};

const boxing_complete_skill = {
  id: 114,
  sport: 'boxing',
  skill: 'complete',
  title: 'Complete Boxing Master',
  description: 'Master all boxing skills',
  difficulty: 'advanced',
  ageRange: '6-10',
  duration: 10,
  points: 30,
  intro:
    "Hey boxing stars! Ready to become a complete boxing master? This skill will teach you everything: boxing basics, footwork, and defense! You'll need some space to practice all your boxing skills safely. Let's get started!",
  completion:
    "PHENOMENAL! You're a COMPLETE BOXING MASTER! You just learned boxing basics, footwork, and defense like a professional! Your complete boxing skills are incredible now, and you're going to be a true boxing champion! You're ready to be the best boxer in your class! You're a true champion!",
};

// Dance Skills
const dance_rhythm_skill = {
  id: 115,
  sport: 'dance',
  skill: 'rhythm',
  title: 'Rhythm Queen',
  description: 'Feel the beat and move with confidence',
  difficulty: 'beginner',
  ageRange: '6-10',
  duration: 10,
  points: 15,
  intro:
    "Hey dance stars! Ready to become a rhythm queen? This skill will teach you to feel the beat and move with confidence! You'll need some music and space to dance around. Let's get started!",
  completion:
    "AMAZING! You're a dance RHYTHM QUEEN! You just learned to feel the music and move with perfect timing! Your rhythm is incredible now, and you're going to dance with confidence! You're ready to be the best dancer in your class! You're a true champion!",
};

const dance_flexibility_skill = {
  id: 110,
  sport: 'dance',
  skill: 'flexibility',
  title: 'Flexibility Star',
  description: 'Become more flexible and graceful',
  difficulty: 'beginner',
  ageRange: '6-10',
  duration: 10,
  points: 15,
  intro:
    "Hey dance stars! Ready to become a flexibility star? This skill will teach you to become more flexible and graceful! You'll need some space to stretch and move around comfortably. Let's get started!",
  completion:
    "INCREDIBLE! You're a dance FLEXIBILITY STAR! You just learned to stretch and move with grace like a professional! Your flexibility is amazing now, and you're going to dance beautifully! You're ready to be the most graceful dancer in your class! You're a true champion!",
};

// Football Skills
const football_throwing_skill = {
  id: 111,
  sport: 'football',
  skill: 'throwing',
  title: 'Throwing Quarterback',
  description: 'Throw the ball like a pro quarterback',
  difficulty: 'beginner',
  ageRange: '6-10',
  duration: 10,
  points: 15,
  intro:
    "Hey football stars! Ready to become a throwing quarterback? This skill will teach you to throw the ball like a pro! You'll need a football and a partner or a target to throw to. Let's get started!",
  completion:
    "AMAZING! You're a football THROWING QUARTERBACK! You just learned to throw the ball with accuracy like a professional! Your throwing skills are incredible now, and you're going to complete passes like a pro! You're ready to be the best quarterback on your team! You're a true champion!",
};

const football_catching_skill = {
  id: 112,
  sport: 'football',
  skill: 'catching',
  title: 'Catching Receiver',
  description: 'Catch every pass that comes your way',
  difficulty: 'beginner',
  ageRange: '6-10',
  duration: 10,
  points: 15,
  intro:
    "Hey football stars! Ready to become a catching receiver? This skill will teach you to catch every pass! You'll need a football and a partner to throw to you, or you can practice with a wall. Let's get started!",
  completion:
    "INCREDIBLE! You're a football CATCHING RECEIVER! You just learned to catch the ball with soft hands like a professional! Your catching skills are amazing now, and you're going to catch every pass! You're ready to be the best receiver on your team! You're a true champion!",
};

// Baseball Skills
const baseball_hitting_skill = {
  id: 113,
  sport: 'baseball',
  skill: 'hitting',
  title: 'Hitting Champion',
  description: 'Hit the ball with power and accuracy',
  difficulty: 'beginner',
  ageRange: '6-10',
  duration: 10,
  points: 15,
  intro:
    "Hey baseball stars! Ready to become a hitting champion? This skill will teach you to hit the ball with power and accuracy! You'll need a baseball bat and a ball, plus a tee or a partner to pitch to you. Let's get started!",
  completion:
    "AMAZING! You're a baseball HITTING CHAMPION! You just learned to hit the ball with power like a professional! Your hitting skills are incredible now, and you're going to hit home runs! You're ready to be the best hitter on your team! You're a true champion!",
};

const baseball_fielding_skill = {
  id: 114,
  sport: 'baseball',
  skill: 'fielding',
  title: 'Fielding Pro',
  description: 'Field the ball like a professional',
  difficulty: 'beginner',
  ageRange: '6-10',
  duration: 10,
  points: 15,
  intro:
    "Hey baseball stars! Ready to become a fielding pro? This skill will teach you to field the ball like a professional! You'll need a baseball and a glove, plus some space to practice catching and throwing. Let's get started!",
  completion:
    "INCREDIBLE! You're a baseball FIELDING PRO! You just learned to field the ball with perfect form like a professional! Your fielding skills are amazing now, and you're going to make amazing plays! You're ready to be the best fielder on your team! You're a true champion!",
};

// Tennis Skills
const tennis_forehand_skill = {
  id: 115,
  sport: 'tennis',
  skill: 'forehand',
  title: 'Forehand Master',
  description: 'Master the forehand stroke',
  difficulty: 'beginner',
  ageRange: '6-10',
  duration: 10,
  points: 15,
  intro:
    "Hey tennis stars! Ready to become a forehand master? This skill will teach you to master the forehand stroke! You'll need a tennis racket and some tennis balls, plus a wall or a partner to practice with. Let's get started!",
  completion:
    "AMAZING! You're a tennis FOREHAND MASTER! You just learned to hit forehands with perfect form like a professional! Your forehand skills are incredible now, and you're going to hit winners! You're ready to be the best forehand player on your team! You're a true champion!",
};

const tennis_backhand_skill = {
  id: 116,
  sport: 'tennis',
  skill: 'backhand',
  title: 'Backhand Pro',
  description: 'Develop a strong backhand',
  difficulty: 'intermediate',
  ageRange: '6-10',
  duration: 10,
  points: 20,
  intro:
    "Hey tennis stars! Ready to become a backhand pro? This skill will teach you to develop a strong backhand! You'll need a tennis racket and some tennis balls, plus a wall or a partner to practice with. Let's get started!",
  completion:
    "INCREDIBLE! You're a tennis BACKHAND PRO! You just learned to hit backhands with power like a professional! Your backhand skills are amazing now, and you're going to hit amazing shots! You're ready to be the best backhand player on your team! You're a true champion!",
};

// Golf Skills
const golf_putting_skill = {
  id: 117,
  sport: 'golf',
  skill: 'putting',
  title: 'Putting Master',
  description: 'Master the art of putting',
  difficulty: 'beginner',
  ageRange: '6-10',
  duration: 10,
  points: 15,
  intro:
    "Hey golf stars! Ready to become a putting master? This skill will teach you to master the art of putting! You'll need a golf putter and some golf balls, plus a flat surface to practice on. Let's get started!",
  completion:
    "AMAZING! You're a golf PUTTING MASTER! You just learned to putt with perfect touch like a professional! Your putting skills are incredible now, and you're going to sink putts! You're ready to be the best putter on your team! You're a true champion!",
};

const golf_chipping_skill = {
  id: 118,
  sport: 'golf',
  skill: 'chipping',
  title: 'Chipping Pro',
  description: 'Get the ball close to the hole',
  difficulty: 'intermediate',
  ageRange: '6-10',
  duration: 10,
  points: 20,
  intro:
    "Hey golf stars! Ready to become a chipping pro? This skill will teach you to get the ball close to the hole! You'll need a golf club and some golf balls, plus some space to practice your chip shots. Let's get started!",
  completion:
    "INCREDIBLE! You're a golf CHIPPING PRO! You just learned to chip with perfect accuracy like a professional! Your chipping skills are amazing now, and you're going to get up and down! You're ready to be the best chipper on your team! You're a true champion!",
};

// Cricket Skills
const cricket_batting_skill = {
  id: 119,
  sport: 'cricket',
  skill: 'batting',
  title: 'Batting Champion',
  description: 'Score runs like a champion',
  difficulty: 'beginner',
  ageRange: '6-10',
  duration: 10,
  points: 15,
  intro:
    "Hey cricket stars! Ready to become a batting champion? This skill will teach you to score runs like a champion! You'll need a cricket bat and ball, plus a partner to bowl to you or a wall to practice against. Let's get started!",
  completion:
    "AMAZING! You're a cricket BATTING CHAMPION! You just learned to bat with perfect technique like a professional! Your batting skills are incredible now, and you're going to score runs! You're ready to be the best batsman on your team! You're a true champion!",
};

const cricket_bowling_skill = {
  id: 120,
  sport: 'cricket',
  skill: 'bowling',
  title: 'Bowling Pro',
  description: 'Bowl with accuracy and control',
  difficulty: 'intermediate',
  ageRange: '6-10',
  duration: 10,
  points: 20,
  intro:
    "Hey cricket stars! Ready to become a bowling pro? This skill will teach you to bowl with accuracy and control! You'll need a cricket ball and some space to practice your bowling action. Let's get started!",
  completion:
    "INCREDIBLE! You're a cricket BOWLING PRO! You just learned to bowl with perfect line and length like a professional! Your bowling skills are amazing now, and you're going to take wickets! You're ready to be the best bowler on your team! You're a true champion!",
};

// Running Technique Skills
const running_form_skill = {
  id: 1150,
  sport: 'running-technique',
  skill: 'Form',
  title: 'Running Form',
  description: 'Learn fundamental running form and technique',
  difficulty: 'beginner',
  ageRange: '6-10',
  duration: 18,
  points: 18,
  intro:
    "Hey running stars! Ready to master running form? This skill will teach you proper running technique! You'll need some space to move around. Let's get started!",
  completion:
    "AMAZING! You're a RUNNING FORM MASTER! You just learned proper running technique like a professional! Your form is incredible now, and you're going to run like champions! You're ready to be the best runner! You're a true champion!",
};

const running_speed_agility_skill = {
  id: 1151,
  sport: 'running-technique',
  skill: 'Speed',
  title: 'Speed & Agility',
  description: 'Master speed and agility techniques',
  difficulty: 'beginner',
  ageRange: '6-10',
  duration: 18,
  points: 18,
  intro:
    "Hey running stars! Ready to master speed and agility? This skill will teach you quick feet and fast movements! You'll need some space to move around. Let's get started!",
  completion:
    "INCREDIBLE! You're a SPEED & AGILITY MASTER! You just learned quick feet and fast movements like a professional! Your speed skills are amazing now, and you're going to move like lightning! You're ready to be the fastest runner! You're a true champion!",
};

const running_beginner_endurance_skill = {
  id: 1152,
  sport: 'running-technique',
  skill: 'Endurance',
  title: 'Beginner Endurance',
  description: 'Build endurance with proper running form',
  difficulty: 'beginner',
  ageRange: '6-10',
  duration: 22,
  points: 22,
  intro:
    "Hey running stars! Ready to build endurance? This skill will teach you to run longer with proper form! You'll need some space to move around. Let's get started!",
  completion:
    "FANTASTIC! You're a BEGINNER ENDURANCE MASTER! You just learned to run longer with proper form like a professional! Your endurance is incredible now, and you're going to run like champions! You're ready to be the best endurance runner! You're a true champion!",
};

const running_intermediate_endurance_skill = {
  id: 1153,
  sport: 'running-technique',
  skill: 'Endurance',
  title: 'Intermediate Endurance',
  description: 'Advanced endurance training with proper form',
  difficulty: 'intermediate',
  ageRange: '6-10',
  duration: 45,
  points: 45,
  intro:
    "Hey running stars! Ready for advanced endurance training? This skill will teach you to run even longer with proper form! You'll need some space to move around. Let's get started!",
  completion:
    "PHENOMENAL! You're an INTERMEDIATE ENDURANCE MASTER! You just learned advanced endurance training like a professional! Your endurance is amazing now, and you're going to run like champions! You're ready to be the best endurance runner! You're a true champion!",
};

// Taekwondo Skills
const taekwondo_basics_skill = {
  id: 1160,
  sport: 'taekwondo',
  skill: 'Basics',
  title: 'Beginner Taekwondo Basics',
  description: 'Learn fundamental taekwondo basics and stances',
  difficulty: 'beginner',
  ageRange: '6-10',
  duration: 16,
  points: 16,
  intro:
    "Hey taekwondo stars! Ready to learn the basics? This skill will teach you fundamental taekwondo moves! You'll need some space to move around. Let's get started!",
  completion:
    "AMAZING! You're a TAEKWONDO BASICS MASTER! You just learned fundamental taekwondo moves like a professional! Your basics are incredible now, and you're going to be a taekwondo champion! You're ready to be the best! You're a true champion!",
};

const taekwondo_kicks_skill = {
  id: 1161,
  sport: 'taekwondo',
  skill: 'Kicks',
  title: 'Intermediate Taekwondo Kicks',
  description: 'Master intermediate taekwondo kicking techniques',
  difficulty: 'intermediate',
  ageRange: '6-10',
  duration: 16,
  points: 16,
  intro:
    "Hey taekwondo stars! Ready to master kicking techniques? This skill will teach you awesome taekwondo kicks! You'll need some space to move around. Let's get started!",
  completion:
    "INCREDIBLE! You're a TAEKWONDO KICKS MASTER! You just learned amazing kicking techniques like a professional! Your kicks are powerful now, and you're going to be unstoppable! You're ready to be the best kicker! You're a true champion!",
};

const taekwondo_techniques_skill = {
  id: 1162,
  sport: 'taekwondo',
  skill: 'Techniques',
  title: 'Advanced Taekwondo Techniques',
  description: 'Master advanced taekwondo techniques and combinations',
  difficulty: 'advanced',
  ageRange: '6-10',
  duration: 17,
  points: 17,
  intro:
    "Hey taekwondo stars! Ready for advanced techniques? This skill will teach you complex taekwondo combinations! You'll need some space to move around. Let's get started!",
  completion:
    "PHENOMENAL! You're an ADVANCED TAEKWONDO MASTER! You just learned complex techniques like a professional! Your skills are incredible now, and you're going to be unstoppable! You're ready to be the best! You're a true champion!",
};

const taekwondo_stances_skill = {
  id: 1163,
  sport: 'taekwondo',
  skill: 'Stances',
  title: 'Beginner Taekwondo Stances',
  description: 'Learn fundamental taekwondo stances and positions',
  difficulty: 'beginner',
  ageRange: '6-10',
  duration: 14,
  points: 14,
  intro:
    "Hey taekwondo stars! Ready to learn stances? This skill will teach you proper taekwondo positions! You'll need some space to move around. Let's get started!",
  completion:
    "FANTASTIC! You're a TAEKWONDO STANCES MASTER! You just learned proper stances like a professional! Your positions are perfect now, and you're going to be a taekwondo champion! You're ready to be the best! You're a true champion!",
};

const taekwondo_footwork_skill = {
  id: 1164,
  sport: 'taekwondo',
  skill: 'Footwork',
  title: 'Intermediate Taekwondo Footwork',
  description: 'Master intermediate taekwondo footwork and movement',
  difficulty: 'intermediate',
  ageRange: '6-10',
  duration: 15,
  points: 15,
  intro:
    "Hey taekwondo stars! Ready to master footwork? This skill will teach you amazing taekwondo movement! You'll need some space to move around. Let's get started!",
  completion:
    "INCREDIBLE! You're a TAEKWONDO FOOTWORK MASTER! You just learned amazing movement like a professional! Your footwork is incredible now, and you're going to be unstoppable! You're ready to be the best! You're a true champion!",
};

const taekwondo_combinations_skill = {
  id: 1165,
  sport: 'taekwondo',
  skill: 'Combinations',
  title: 'Advanced Taekwondo Combinations',
  description: 'Master advanced taekwondo combinations and sequences',
  difficulty: 'advanced',
  ageRange: '6-10',
  duration: 16,
  points: 16,
  intro:
    "Hey taekwondo stars! Ready for advanced combinations? This skill will teach you complex taekwondo sequences! You'll need some space to move around. Let's get started!",
  completion:
    "PHENOMENAL! You're an ADVANCED COMBINATIONS MASTER! You just learned complex sequences like a professional! Your combinations are incredible now, and you're going to be unstoppable! You're ready to be the best! You're a true champion!",
};

const taekwondo_defense_skill = {
  id: 1166,
  sport: 'taekwondo',
  skill: 'Defense',
  title: 'Beginner Taekwondo Defense',
  description: 'Learn fundamental taekwondo defense and blocking',
  difficulty: 'beginner',
  ageRange: '6-10',
  duration: 13,
  points: 13,
  intro:
    "Hey taekwondo stars! Ready to learn defense? This skill will teach you proper taekwondo blocking! You'll need some space to move around. Let's get started!",
  completion:
    "FANTASTIC! You're a TAEKWONDO DEFENSE MASTER! You just learned proper blocking like a professional! Your defense is incredible now, and you're going to be unstoppable! You're ready to be the best! You're a true champion!",
};

const taekwondo_sparring_skill = {
  id: 1167,
  sport: 'taekwondo',
  skill: 'Sparring',
  title: 'Intermediate Taekwondo Sparring',
  description: 'Master intermediate taekwondo sparring techniques',
  difficulty: 'intermediate',
  ageRange: '6-10',
  duration: 16,
  points: 16,
  intro:
    "Hey taekwondo stars! Ready to master sparring? This skill will teach you amazing taekwondo sparring! You'll need some space to move around. Let's get started!",
  completion:
    "INCREDIBLE! You're a TAEKWONDO SPARRING MASTER! You just learned amazing sparring like a professional! Your sparring is incredible now, and you're going to be unstoppable! You're ready to be the best! You're a true champion!",
};

const taekwondo_forms_skill = {
  id: 1168,
  sport: 'taekwondo',
  skill: 'Forms',
  title: 'Advanced Taekwondo Forms',
  description: 'Master advanced taekwondo forms and patterns',
  difficulty: 'advanced',
  ageRange: '6-10',
  duration: 15,
  points: 15,
  intro:
    "Hey taekwondo stars! Ready for advanced forms? This skill will teach you complex taekwondo patterns! You'll need some space to move around. Let's get started!",
  completion:
    "PHENOMENAL! You're an ADVANCED FORMS MASTER! You just learned complex patterns like a professional! Your forms are incredible now, and you're going to be unstoppable! You're ready to be the best! You're a true champion!",
};

export {
  soccer_dribbling_skill,
  soccer_passing_skill,
  soccer_technique_skill,
  soccer_partner_passing_skill,
  soccer_partner_control_skill,
  soccer_partner_dribbling_skill,
  soccer_partner_skills_skill,
  basketball_dribbling_skill,
  basketball_shooting_skill,
  basketball_defense_skill,
  martial_arts_beginner_stances_skill,
  martial_arts_intermediate_stances_skill,
  martial_arts_advanced_stances_skill,
  martial_arts_beginner_strikes_skill,
  martial_arts_intermediate_strikes_skill,
  martial_arts_advanced_strikes_skill,
  martial_arts_beginner_blocks_skill,
  martial_arts_intermediate_blocks_skill,
  martial_arts_advanced_blocks_skill,
  boxing_basics_skill,
  boxing_footwork_skill,
  boxing_defense_skill,
  boxing_complete_skill,
  dance_rhythm_skill,
  dance_flexibility_skill,
  football_throwing_skill,
  football_catching_skill,
  baseball_hitting_skill,
  baseball_fielding_skill,
  tennis_forehand_skill,
  tennis_backhand_skill,
  golf_putting_skill,
  golf_chipping_skill,
  cricket_batting_skill,
  cricket_bowling_skill,
  running_form_skill,
  running_speed_agility_skill,
  running_beginner_endurance_skill,
  running_intermediate_endurance_skill,
  taekwondo_basics_skill,
  taekwondo_kicks_skill,
  taekwondo_techniques_skill,
  taekwondo_stances_skill,
  taekwondo_footwork_skill,
  taekwondo_combinations_skill,
  taekwondo_defense_skill,
  taekwondo_sparring_skill,
  taekwondo_forms_skill,
};
